<div class="header-card d-flex bottom-xs">
  <h2 class="color-blue-light header-card_title u-medium">{{titleSite}}</h2>
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
  <h2 class="color-blue-light header-card_title u-medium">{{numAffiliates|number}}</h2>
</div>